import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1bd2a007")

_pushScopeId("data-v-1bd2a007")
const _hoisted_1 = {
  class: "writing-board",
  ref: "writingBoardRef"
}
const _hoisted_2 = {
  class: "canvas",
  ref: "canvasRef"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("canvas", _hoisted_2, null, 512)
  ], 512))
})